import { callApi } from './api';

import { School, CreateSchoolRequest } from '@/types/school';

export const createSchool = async (requestBody: CreateSchoolRequest) => {
  const { status, result } = await callApi<School>(
    'schools',
    'POST',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
